import { type ForwardedRef } from 'react';

type Props = {
  children: React.ReactNode;
  ariaLabel: string;
  className: string;
  disabled: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onKeyUp: React.KeyboardEventHandler<HTMLButtonElement>;
  ref?: ForwardedRef<Element extends 'a' ? HTMLAnchorElement : HTMLButtonElement>;
  testID?: string;
};

export default function TextLink(props: Props): JSX.Element {
  const { children, ariaLabel, className, disabled, onClick, onKeyUp, ref, testID } = props;
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      onClick={onClick}
      onKeyUp={onKeyUp}
      ref={ref}
      data-cvent-id={testID}
    >
      {children}
    </button>
  );
}
